import { Navigate } from "react-router-dom";

export default function InstitutionClinicianInvitationReview() {
  // The old deep link had no notification row id. Keep it harmless for old
  // bookmarks, while all current bell entries open the canonical detail.
  return <Navigate to="/settings/doctor/notifications" replace />;
}
